import { render, staticRenderFns } from "./StepperIntegracionMovil.vue?vue&type=template&id=2052c3fc&scoped=true&"
import script from "./StepperIntegracionMovil.vue?vue&type=script&lang=js&"
export * from "./StepperIntegracionMovil.vue?vue&type=script&lang=js&"
import style0 from "./StepperIntegracionMovil.vue?vue&type=style&index=0&id=2052c3fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052c3fc",
  null
  
)

export default component.exports